import { render } from "./AssetLibrary.vue?vue&type=template&id=6ebec920"
import script from "./AssetLibrary.vue?vue&type=script&lang=js"
export * from "./AssetLibrary.vue?vue&type=script&lang=js"

import "./AssetLibrary.vue?vue&type=style&index=0&id=6ebec920&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__